// [...] - Любой символ из заданных
export const CYRILLIC_SYMBOLS = /[а-я]/gi;

// (...) - Скобочная группа
// ?! - Негативное заглядывание вперед (если не)
// \W - Любой символ, кроме \w, то есть не буквы из латиницы, не знак подчёркивания и не цифра
export const UNALLOWED_PROJECT_SYMBOLS = /(?![.,:!*-])(\W)/g;

// \D - Не цифра: любой символ, кроме \d (например буква)
// + - Квантификатор: означает «один или более»
export const ANY_NON_WHOLE_NUMBER_SYMBOLS = /\D+/g;

// ^ - начало строки
// [^...] - любой символ КРОМЕ указанных
// | - объединение правил (можно воспринимать как "и"/"или")
// (?!^) - если не начало строки
// \D - Не цифра: любой символ, кроме \d (например буква)
// + - Квантификатор: означает «один или более»
export const UNALLOWED_PHONE_SYMBOLS = /^[^+\d]|(?!^)\D+/g;

// ^ - начало строки
// \D - Не цифра: любой символ, кроме \d (например буква)
// | - объединение правил (можно воспринимать как "и"/"или")
// [^...] - любой символ КРОМЕ указанных
// \d - десятичная цифра
export const UNALLOWED_DATE_SYMBOLS = /^\D|[^.-\d]/g;

// (?<=...) - Положительное заглядывание назад (Positive lookbehind)
// (...) - Скобочная группа
// | - объединение правил (можно воспринимать как "и"/"или")
// Можно прочитать так: выбрать точку, перед которой есть дефис или точка
export const UNALLOWED_DATE_DOTS = /(?<=(-|\.))\./g;

// (?<=...) - Положительное заглядывание назад (Positive lookbehind)
// (...) - Скобочная группа
// | - объединение правил (можно воспринимать как "и"/"или")
// Можно прочитать так: выбрать дефис, перед которым есть ЛИБО дефис и от 0 до сколько угодно символов после него ЛИБО точка
export const UNALLOWED_DATE_HYPHENS = /(?<=([-].*|\.))-/g;

// (...) - Скобочная группа
// [^...] - любой символ КРОМЕ указанных
// \d - десятичная цифра от 0 до 9
// | - объединение правил (можно воспринимать как "и")
// ^ - начало строки
// (?<=) - позитивное заглядывание назад (положительный Lookbehind)
// Регулярка выделяет следующие паттерны (все они разделены символом '|'):
// - всё, кроме запятых и цифр ([^,\d]);
// - запятую или ноль в начале строки (^[,0]);
// - запятую или ноль, если перед ними запятая ((?<=[,])[,0])
export const TIP_PERCENT_VARIANTS_INPUT_RULE = /([^,\d])|(^[,0])/g;

export const TIP_PERCENT_VARIANT_REPLACE_COMMAS_RULE = /,([,0])/g;
